import { put } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';
import { accessDigimail } from './sessions';
import { getText } from 'misc/helpers';
import { popup_icon_type } from 'components/shared/popup/Popup';

export function* getAgreement(action) {
    try {
        const response = yield endpoint.get('agreements?active=true');
        yield put({ type: types.SAGA_AGREEMENT_GET.SUCCESS, payload: response.data });

        if(action.ref === 'login'){
            // Loop through all agreements, check if any of them are NOT_ACCEPTED
            let accessInbox = true;
            response.data.forEach(function(agreement, index) {
                if (agreement.status === 'NOT_ACCEPTED') {
                    accessInbox = false;
                }
            });
    
            if (!accessInbox) {
                yield put(push('/accept/'));
            } else {
                accessDigimail(action.customerId, true);
            }
        }
    } catch (error) {
        yield put({ type: types.SAGA_AGREEMENT_GET.FAILURE, error });
    }
}

export function* putAgreement(action) {
    if(!action.payload.agree){
        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                header: '',
                text: getText('Missing', 'Du måste godkänna villkoren för att fortsätta kunna använda Digimail')
            }
        });

        yield put({ type: types.SAGA_AGREEMENT_PUT.FAILURE, error: "User did not accept agreement" });
    }else{
       try {
            let response = yield endpoint.put('agreements/' + action.payload.agreementId + '?actions=ACCEPT');
            yield put({ type: types.SAGA_AGREEMENT_PUT.SUCCESS, payload: response.data });
           
            if (response.status === 200) {
                yield put({ type: types.SAGA_SESSION_GET.REQUEST, customerId: action.payload.customerId });
            }
        } catch (error) {
            yield put({ type: types.SAGA_AGREEMENT_PUT.FAILURE, error });
        }
    }
}



// WEBPACK FOOTER //
// ./src/sagas/agreement.js